import React from 'react'

export default function LoadingSpinner() {
    return <div className="loading-spinner"></div>
}


// WEBPACK FOOTER //
// ./src/components/Global/LoadingSpinner.js